var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",on:{"click":_vm.handleClick}}),_c('div',{staticClass:"overlay clickthroug",attrs:{"id":"canvasOverlay"},on:{"click":_vm.next}},[_c('div',{staticClass:"subtitles"},[_vm._v(_vm._s(_vm.subtitles))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }